import React, { useState, useEffect } from 'react';
import { FiUserPlus, FiLogIn } from "react-icons/fi"
import { Navigate, useNavigate } from 'react-router';

import { Link } from "react-router-dom"

import { db, auth } from '../functions/firebaseFunctions'
import ItemYORP from './ItemYORP';

const AccTypes = ['Standard', 'Artist', 'Business'];
//account types descriptions
const accTypesDes = {
  Standard: 'Standart account allows to create events, book entertainment and venues',
  Artist: 'Artist account allows to provide entertainment services for events',
  Business: 'Business account allows to rent out your venues for events',
};

const RegisterForm = (props) => {

  const [Err, setErr] = useState(null);
  const [AccType, setAccType] = useState('Standard');
  const [password, setPassword] = useState('');
  const navigateTo = useNavigate();
  const [emailStatus, setEmailStatus] = useState(undefined);
  const [unameStatus, setUnameStatus] = useState(undefined);
  const [passwordStatus, setPasswordStatus] = useState(undefined);
  const [repeatPasswordStatus, setRepeatPasswordStatus] = useState(undefined);

  const register = async event => {
    event.preventDefault()
    const { email, uname, password, repeatPassword } = event.target
    if (!email.value || !password.value || !repeatPassword.value || !uname.value) {
      if (!email.value) { setEmailStatus('empty') }
      if (!uname.value) { setUnameStatus('empty') }
      if (!password.value) { setPasswordStatus('empty') }
      if (!repeatPassword.value) { setRepeatPasswordStatus('empty') }
      setErr({ code: 'EmptyFields', message: 'Fill in all the fields' })
      console.log('error');
    }
    else if (password.value != repeatPassword.value) { console.log('error'); setErr({ code: 'PwdMatch', message: 'The passwords you entered do not match' }); } else
      if (!Err) {
        setErr(null);
        auth.createUserWithEmailAndPassword(email.value, password.value).then(({ user: { uid } }) => {

          auth.currentUser.updateProfile({
            displayName: uname.value,
          }).then(() => {
            if (AccType !== 'Standard') {
              console.log('type !standard')
              db.collection('users').doc(uid).set({
                email: email.value,
                name: uname.value,
                uid: uid,
                type: AccType,
              })
                .then(() => {
                  navigateTo('/Profile/dashboard');
                })
                .catch((error) => {
                  setErr(error);
                });
            }
            else {
              db.collection('users').doc(uid).set({
                // info:uname
                name: uname.value,
                uid: uid,
                email: email.value,
              })
                .then(() => {
                  navigateTo('/Profile/dashboard');
                })
                .catch((error) => {
                  setErr(error);
                });
            }
          }).catch(e => { console.log('nameupdate', e) });



        }).catch((e) => { setErr(e); console.log('create', e) });
      }
  }
  if (auth.currentUser) { return (<Navigate to="/Profile/dashboard" />) }
  else {
    return (
      <>
        <form onSubmit={register} className='logForms'>
          <img alt='PartyLivePrototype' src='/Logo.png'
            style={{ width: 300, height: 160, marginTop: 40, marginBottom: 20, alignSelf: 'center' }}
          />
          {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
          <p style={{ fontSize: 16, color: 'var(--wht)', textAlign: 'center', paddingBottom: 5 }}>Select the account type:</p>
          <div style={{ 
            paddingBottom: 10, 
            justifyContent: 'center', 
            display: 'grid', 
            gridTemplateColumns: '1fr 1fr 1fr', 
            gap: '5px' 
          }}>
            {AccTypes.map(item => 
            <ItemYORP 
              title={item}
              key={item}
              sel={AccType}
              onClick={() => {
                setAccType(item); setErr(null);
              }} />)}
          </div>
          <p style={{ fontSize: 16, color: 'var(--ltg)', textAlign: 'center', paddingBottom: 5 }}>{accTypesDes[AccType]}</p>
          <input
            className='ProfileInput'
            placeholder="Username"
            autocompletetype="username"
            name='uname'
            style={Err && (Err.code == 'NameEmpty' || (Err.code == 'EmptyFields' && unameStatus === 'empty'))
              ? { borderColor: 'tomato' }
              : (unameStatus === 'correct' ? { borderColor: 'var(--ltg)', animation: 'none' } : null)}
            onBlur={unameInput => {
              if (!unameInput.target.value) { setErr({ code: 'NameEmpty', message: 'Username field can not be empty', }); }
              else { setUnameStatus('correct') }
            }}
            maxLength={100}
          />
          <input
            className='ProfileInput'
            placeholder="E-mail"
            autocompletetype="email"
            autoCapitalize="none"
            name='email'
            style={Err &&
              (Err.code == 'ValEmail' || (Err.code == 'EmptyFields' && emailStatus === 'empty') || Err.code == 'auth/invalid-email' || Err.code == 'auth/email-already-in-use')
              ? { borderColor: 'tomato', animation: 'none' }
              : (emailStatus === 'correct' ? { borderColor: 'var(--ltg)', animation: 'none' } : null)}
            maxLength={100}
            onBlur={emailInput => {
              if (emailInput.target.value && /.+@.+\..+/.test(emailInput.target.value)) { setEmailStatus('correct'); setErr(null); }
              else { setErr({ code: 'ValEmail', message: 'Please enter a valid e-mail' }); }
            }}

          />
          <input
            className='ProfileInput '
            placeholder="Password"
            autocompletetype="password"
            autoCapitalize="none"
            type='password'
            name='password'
            style={Err && (Err.code == 'PwdEmpty' || Err.code == 'PwdShort' || Err.code == 'PwdMatch' || (Err.code == 'EmptyFields' && !password.target.value))
              ? { borderColor: 'tomato', animation: 'none' }
              : (passwordStatus === ('correct') ? { borderColor: 'var(--ltg)', animation: 'none' } : null)}
            // onBlur={object=>{console.log(object)}}
            onBlur={passwordInput => {
              if (!passwordInput.target.value) { setErr({ code: 'PwdEmpty', message: 'Password field can not be empty' }); setPasswordStatus('correct'); }
              else {
                if (passwordInput.target.value.length > 5) { setErr(null); setPasswordStatus('correct'); setPassword(passwordInput.target.value) }
                else { setErr({ code: 'PwdShort', message: 'The password has to be at least 6 characters' }); setPasswordStatus(undefined); }
              }
            }}
            maxLength={100}
          />
          <input
            className='ProfileInput '
            placeholder="Repeat Password"
            autocompletetype="password"
            autoCapitalize="none"
            type='password'
            name='repeatPassword'
            style={Err && (Err.code == 'PwdMatch' || (Err.code == 'EmptyFields' && repeatPasswordStatus === 'empty'))
              ? { borderColor: 'tomato', animation: 'none' }
              : (repeatPasswordStatus === 'correct' ? { borderColor: 'var(--ltg)', animation: 'none' } : null)}
            maxLength={100}
            onBlur={repeatPasswordInput => {
              if (repeatPasswordInput.target.value === password) { setErr(null); setRepeatPasswordStatus('correct'); } else { setErr({ code: 'PwdMatch', message: 'The passwords you entered do not match' }) }
            }}
          />
          <button className='btnYorp' style={{ width: '100%' }} type='submit'>
            <p>Register</p>
            <FiUserPlus />
          </button>
        </form>
        <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
          <div  style={{width: '320px'}}>
            <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
            <nav style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Link className='RegisterResetButtons'
                to="/Profile/login"
              >
                <p className='ProfileText'>Login</p>
                <FiLogIn style={{ margin: 5, color: 'var(--ltg)', }} />
              </Link>
              <Link className='RegisterResetButtons'
                to="/Profile/reset_password"
              >
                <p className='ProfileText'>Forgot Password</p>
              </Link>
            </nav>
            <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
          </div>
        </div>
      </>
    )
  };
};

export default RegisterForm;
